import { BaseEntity } from './../../../base-models/base-entity';
import { BaseContainerService } from './base-container-service';
import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable, interval } from 'rxjs';
import { ModelData } from '../../../base-models/model-data';
import { ModalService } from '../../../base-services/modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParentProperty } from '../../../base-models/parent-property';
import { QueryParameter } from './../../../base-models/query-parameter';
import { take, tap, switchMap, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TabsContainerService<T extends BaseEntity> extends BaseContainerService<T> {
  constructor(protected modalService: ModalService,
            protected ngbModalService: NgbModal,
            private ngZone: NgZone){
        super();
    }

    random: number = Math.random();

    private activeTabSubject: Subject<string> = new Subject<string>();

    ActiveTab: Observable<string> = this.activeTabSubject.asObservable();

    IsListTabDisabled = false;
    IsUpdateTabDisabled = true;

    name;

    private logTabFlowDebug(methodName: string, data: any){
        const w = typeof window !== 'undefined' ? (window as any) : null;
        if (!w || w.__TAB_FLOW_DEBUG !== true){
            return;
        }
        console.log('[TAB-FLOW-DEBUG]', methodName, data);
    }


    ShowList(){
        this.logTabFlowDebug('ShowList', {
            timestamp: Date.now(),
            currentTab: 'tbList',
            itemID: null,
            idParameter: null,
            mainItemsExists: null,
            mainItemsCount: null,
            selectedItemExists: null,
            selectedItemID: null,
            refreshType: null,
            detailListExists: null,
            detailListCount: null
        });
        this.selectTab('tbList');
    }

    ShowUpdate(){
        this.selectTab('tbUpdate');
    }

    // ShowListAfterEnable() {
    //     this.IsListTabDisabled = false;

    //     this.ngZone.onStable
    //         .pipe(take(1))
    //         .subscribe(() => {
    //             this.selectTab('tbList');
    //             this.IsUpdateTabDisabled = true;
    //         });
    // }

    ShowListAfterEnable(): Observable<void> {
        this.IsListTabDisabled = false;

        return this.ngZone.onStable.pipe(
            take(1),
            tap(() => {
                this.selectTab('tbList');
            }),
            switchMap(() => this.ngZone.onStable.pipe(take(1))),
            tap(() => {
                this.IsUpdateTabDisabled = true;
            }),
            map(() => undefined)
        );
    }

    AddItem(){
        // console.log('TabsContainerService:'+ "AddItem");
        this.IsUpdateTabDisabled = false;
        setTimeout(() => {
            this.selectTab('tbUpdate');
            this.IsListTabDisabled = true;            
        }, 100);
        this.SelectItem(-1);
        //interval(1000)
            //.subscribe(i => {                
                //this.SelectItem(-1)
            //})      
        //this.delay(5000);
        //this.SelectItem(-1);
        //alert('Add item tabs container service');
    }
    AddDetailItem(modelData: ModelData, parentProperty: ParentProperty = null, parameters: QueryParameter[] = null) {
      this.modalService.ShowModal(-1, modelData, parentProperty, true, parameters)
        .result
        .then((item) => {
          this.EmitItem(item);
        }, (reason) => {

        })
    }

    EditItem(modelData: ModelData, ID: number){
        this.IsUpdateTabDisabled = false;
        setTimeout(() => {           
            this.selectTab('tbUpdate');
            this.IsListTabDisabled = true;
        }, 100);
        this.SelectItem(ID);
    }
    EditDetailItem(modelData: ModelData, ID: number, parentProperty: ParentProperty = null, parameters: QueryParameter[] = null) {
      this.modalService.ShowModal(ID, modelData, parentProperty, true, parameters)
        .result
        .then((item) => {
          this.EmitItem(item);
        }, (reason) => {

        });
    }

    // AddItem2(){
    //     console.log('TabsContainerService2:'+ "AddItem2");
    //     this.IsUpdateTabDisabled = false;
    //     setTimeout(() => {
    //         this.selectTab('tbUpdate2');
    //         this.IsListTabDisabled = true;            
    //     }, 100);
    //     this.SelectItem(-1);
    // }

    // EditItem2(modelData: ModelData, ID: number){
    //     this.IsUpdateTabDisabled = false;
    //     setTimeout(() => {           
    //         this.selectTab('tbUpdate2');
    //         this.IsListTabDisabled = true;
    //     }, 100);
    //     this.SelectItem(ID);
    // }


    private selectTab(tabID: string){
        this.activeTabSubject.next(tabID);
    }

    //private async delay(ms: number){
        //return new Promise(resolve => setTimeout(resolve, ms));
    //}
}
